export enum MonsterCatchResult {
  Missed,
  Caught,
  Fled,
}
